<h2 mat-dialog-title>{{ formTitle }}</h2>

<mat-dialog-content>
    <div>
        <mat-form-field>
            <mat-label>Config</mat-label>
            <mat-select [(value)]="configGuid">
                <mat-option>None</mat-option>
                <mat-option *ngFor="let config of configs" [value]="config.guid">{{
                    config.name }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div>
        <mat-form-field>
            <input matInput placeholder="Schedule Name" [(ngModel)]="name">
        </mat-form-field>
    </div>
    <div>
        <mat-form-field>
            <mat-label>Frequency Type</mat-label>
            <mat-select [(value)]="frequencyType" (selectionChange)="onFrequencyTypeChanged($event)">
                <mat-option>None</mat-option>
                <mat-option *ngFor="let frequencyType of frequencyTypes" [value]="frequencyType.value">{{
                    frequencyType.text }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div>
        <mat-form-field>
            <mat-label>Days</mat-label>
            <mat-select #daysSelect title="{{selectedDays}}" [(value)]="selectedDays" (selectionChange)="onDaysCheckedChanged($event)" multiple>
                <mat-select-trigger>{{ selectedDays }}</mat-select-trigger>
                <mat-option *ngFor="let day of daysOptions" [value]="day.text" >
                    {{day.text}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div>
        <mat-form-field>
            <mat-label>Active Start Date</mat-label>
            <input [(ngModel)]="startDate" matInput [matDatepicker]="picker">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
    </div>
    <div>
        <mat-form-field>
            <mat-label>Active Start Time</mat-label>
            <input [(ngModel)]="startTime" matInput [ngxTimepicker]="timePicker">
            <mat-datepicker-toggle matSuffix [for]="$any(timePicker)"><mat-icon class="white-icon" matDatepickerToggleIcon>access_time</mat-icon></mat-datepicker-toggle>
            <ngx-material-timepicker #timePicker></ngx-material-timepicker>
          </mat-form-field>
    </div>
    <div>
        <mat-form-field>
            <mat-label>Retry Attempts</mat-label>
            <input matInput [(ngModel)]="retryAttempts">
          </mat-form-field>
    </div>
    <div>
        <mat-form-field>
            <mat-label>Retry Interval (min)</mat-label>
            <input matInput [(ngModel)]="retryInterval">
          </mat-form-field>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button (click)="save()" color="primary" mat-raised-button tabindex="-1">SAVE SCHEDULE</button>
    <button (click)="cancel()" mat-raised-button mat-dialog-close tabindex="-1">CANCEL</button>
</mat-dialog-actions>